// Utility functions for price calculations

/**
 * Apply 10% markup to admin price and round to nearest 5 or 0
 * @param {number} adminPrice - Original price set by admin
 * @returns {number} - Marked up and rounded price
 */
export const applyPriceMarkup = (adminPrice) => {
  if (!adminPrice || adminPrice <= 0) return 0;
  
  // Add 10% markup
  const markedUpPrice = adminPrice * 1.10;
  
  // Round to nearest integer
  let roundedPrice = Math.round(markedUpPrice);
  
  // Get the last digit
  const lastDigit = roundedPrice % 10;
  
  // If last digit is not 0 or 5, round to nearest 5 or 0
  if (lastDigit !== 0 && lastDigit !== 5) {
    if (lastDigit < 3) {
      // Round down to 0
      roundedPrice = roundedPrice - lastDigit;
    } else if (lastDigit < 8) {
      // Round to 5
      roundedPrice = roundedPrice - lastDigit + 5;
    } else {
      // Round up to next 0
      roundedPrice = roundedPrice + (10 - lastDigit);
    }
  }
  
  return roundedPrice;
};

/**
 * Calculate platform fee (8% of subtotal)
 * @param {number} subtotal - Cart subtotal
 * @returns {number} - Platform fee amount
 */
export const calculatePlatformFee = (subtotal) => {
  return subtotal * 0.08;
};
